// extracted by mini-css-extract-plugin
export default {"betting-grid":"home_betting-grid__d5yAH","user-section":"home_user-section__MzSwd","day-section":"home_day-section__0GImS","cards-container":"home_cards-container__ACvWO"};